import { Pipe, PipeTransform } from '@angular/core';


export enum EnergyConversion {
  WH_KWH = 'WH-KWH', // Kilowatthours
  KWH_WH = 'KWH-WH' // Watthours
}

/**
 * This pipe is used to convert energy consumptions, e.g. Watthours to Kilowatthours
 */
@Pipe({
  name: 'convertEnergy',
  pure: true
})
export class MmuEnergyPipe implements PipeTransform {
  transform(value: number, conversion: EnergyConversion): number {
    switch (conversion) {
      case EnergyConversion.WH_KWH:
        return value / 1000;
      case EnergyConversion.KWH_WH:
        return value * 1000;
    }
  }
}
